import { useEffect, useCallback } from 'react'
import { CAT_COLORS } from './useRecipeState'

const RecipeHeader = ({ svc, tmpl, dirty, saving, minimumTotal, setMinimumTotal, onSave, onClose, markDirty }) => {
  const catColor = CAT_COLORS[svc?.category] || '#6b7280'

  const handleSave = useCallback((e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 's') {
      e.preventDefault()
      onSave()
    }
  }, [onSave])

  useEffect(() => {
    document.addEventListener('keydown', handleSave)
    return () => document.removeEventListener('keydown', handleSave)
  }, [handleSave])

  return (
    <div className="recipe-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--ink)' }}>
          {svc?.name || 'Untitled Recipe'}
        </div>

        <span className="cat-chip" style={{ color: catColor, backgroundColor: `${catColor}14` }}>
          {svc?.category}
        </span>

        {tmpl && (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)', background: 'var(--bg-2)', padding: '3px 8px', borderRadius: 6 }}>
            key: {svc?.serviceId}
          </span>
        )}

        {dirty && <span className="dirty-dot" title="Unsaved changes" />}
      </div>

      <div className="header-actions">
        {/* Recipe Min — demoted from green pill to plain labelled input */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span className="overline-label">Recipe min</span>
          <div className="recipe-min-wrap">
            <span className="recipe-min-prefix">$</span>
            <input
              type="number"
              className="recipe-min-input"
              value={minimumTotal ?? ''}
              placeholder="0"
              onChange={e => {
                setMinimumTotal(e.target.value ? parseFloat(e.target.value) : null)
                markDirty()
              }}
            />
          </div>
        </div>

        {/* Close is ghost, Save is primary */}
        <button className="btn btn-ghost" onClick={onClose}>
          Close
        </button>

        <button className="btn btn-primary" onClick={onSave} disabled={saving || !dirty}>
          {saving ? 'Saving...' : 'Save recipe'}
        </button>
      </div>
    </div>
  )
}

export default RecipeHeader
